'use client';

import { createContext, useContext, useState } from 'react';

import type { JourneyGuideQueryData } from '~/libs/dato/queries/journeyGuide';

const useJourneyGuideState = (initialJourneyGuide: JourneyGuideQueryData) =>
  useState<JourneyGuideQueryData>(initialJourneyGuide);

const JourneyGuideContext = createContext<ReturnType<typeof useJourneyGuideState> | null>(null);

const JourneyGuideProvider = ({
  journeyGuide: initialJourneyGuide,
  children
}: {
  journeyGuide: JourneyGuideQueryData;
  children: React.ReactNode;
}) => {
  const [journeyGuide, setJourneyGuide] = useState<JourneyGuideQueryData>(initialJourneyGuide);

  return (
    <JourneyGuideContext.Provider value={[journeyGuide, setJourneyGuide]}>{children}</JourneyGuideContext.Provider>
  );
};

const useJourneyGuide = () => {
  const journeyGuide = useContext(JourneyGuideContext);
  if (!journeyGuide) {
    throw new Error('useJourneyGuide must be used within a JourneyGuideStateProvider');
  }
  return journeyGuide;
};

export { JourneyGuideProvider, useJourneyGuide };
